export const VERY_BIG_DESKTOP_WIDTH = 1400

export const BIG_DESKTOP_WIDTH = 1200

export const DESKTOP_WIDTH = 992

export const TABLET_WIDTH = 768

export const STANDARD_MODILE_WIDTH = 576
